import React from "react";
import { Button } from "app/components";
import { Plus, Minus } from "@phosphor-icons/react";
import { Accordion } from "app/components";

const TicketCategory = ({
  id,
  category,
  activeCategory,
  setActiveCategory,
  isAccordionOpen,
  toggleAccordion,
  onTicketChange,
  selectedCount,
  availableQuantity,
}) => {
  const incrementTicket = () => {
    if (selectedCount < 10) {
      onTicketChange(id, selectedCount + 1);
    }
  };

  const decrementTicket = () => {
    if (selectedCount > 0) {
      onTicketChange(id, selectedCount - 1);
    }
  };

  return (
    <div>
      <div className="flex justify-between mb-2">
        <div className="flex flex-col gap-2">
          <h1 className="heading-16">{category?.option_value_1}</h1>
          <p className="label-14">
            {category?.is_paid ? `₹${Number(category?.price)}` : "Free"}
          </p>
        </div>

        {selectedCount === 0 ? (
          <Button
            type="secondary"
            className="add-btn"
            onClick={() => incrementTicket()}
            disabled={!availableQuantity || category?.is_sold_out}
          >
            {(!availableQuantity || category?.is_sold_out) ? 'Sold out' : (<>ADD <Plus size={16} /></>)}
          </Button>
        ) : (
          <div className="w-[88px] h-[32px] flex items-center justify-between bg-primary pl-2.5 pr-2 py-2 rounded-md">
            <Button
              className="control-btn"
              onClick={() => decrementTicket()}
              disabled={selectedCount === 0}
            >
              <Minus size={16} />
            </Button>
            <span className="label-14 text-white">{selectedCount}</span>
            <Button
              className="control-btn"
              onClick={() => incrementTicket()}
              disabled={selectedCount === Number(category?.max_occupancy)}
            >
              <Plus size={16} />
            </Button>
          </div>
        )}
      </div>

      {category && category?.description !== "" && (
        <Accordion
          content={category?.description}
          title="Details"
          className="accordion-details"
          width=""
          isOpen={isAccordionOpen}
          onToggle={toggleAccordion}
        />
      )}
    </div>
  );
};

export default TicketCategory;
